import styled from "styled-components";

export const options = {
  justifyContent: {
    left: "start",
    center: "center",
    right: "end",
  },
};

export const DesignContainer = styled.div``;
